import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBottle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconBottle"><Path d="M9.375 1C8.96079 1 8.625 1.33579 8.625 1.75C8.625 2.12162 8.89529 2.43012 9.25 2.48963V6.92163L6.24129 9.6989C6.08748 9.84088 6 10.0407 6 10.25V22.25C6 22.6642 6.33579 23 6.75 23H17.25C17.6642 23 18 22.6642 18 22.25V10.25C18 10.0407 17.9125 9.84088 17.7587 9.6989L14.75 6.92163V2.48963C15.1047 2.43012 15.375 2.12162 15.375 1.75C15.375 1.33579 15.0392 1 14.625 1H9.375Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBottle;
